import { render, staticRenderFns } from "./CreateFireAlarmModal.vue?vue&type=template&id=d2bfdb06&"
import script from "./CreateFireAlarmModal.vue?vue&type=script&lang=js&"
export * from "./CreateFireAlarmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports